import { Modal, Input, Select, Button, Space, Divider, Checkbox, Tooltip } from "antd";

const { Option } = Select;

const AddEditUserModal = ({
  // Modal control
  isOpen,
  onOk,
  onCancel,
  modalType, // 'add' or 'edit'
  
  // Form values
  EmployeeId,
  setEmployeeId,
  UserName,
  setUserName,
  Email,
  setEmail,
  Status,
  setStatus,
  Role,
  setRole,
  level,
  SetLevel,
  domain,
  setDomain,
  department,
  setDepartment,
  managerId,
  setManagerId,
  teamId,
  setteamId,
  TeamId,
  setTeamId,
  isNewBatch,
  setIsNewBatch,
  TeamNameDefault,
  
  // Options
  CompanyOptions,
  TeamOptions,
  managerOptions,
  levels,
  setLevels,
  domains,
  setDomains,
  departments,
  setDepartments,
  
  // Error handling
  errors,
  emailError,
  handleEmail,
  
  // Level management
  newLevel,
  setNewLevel,
  handleLevelAdd,
  handleLevelDelete,
  
  // Domain management
  NewDomain,
  setNewDomain,
  handleDomainAdd,
  handleDomainDelete,
  
  // Department management
  NewDepartment,
  setNewDepartment,
  handleDepartmentAdd,
  handleDepartmentDelete,
  
  // Handlers
  handleChange,
  handlechangeTeam,
  handleChangeRole,
  handleChangeLevel,
  handleChangeDomain,
  handleChangeDepartment,
  handleChangeTeam,
  handleChangeManager,
}) => {
  const isEditMode = modalType === 'edit';
  
  return (
    <Modal
      title={isEditMode ? "Edit User" : "Add User"}
      open={isOpen}
      onOk={onOk}
      onCancel={onCancel}
    >
      <h3 style={{ marginTop: 20 }} className="Title">
        Employee Id {!isEditMode && <span className="requiredStar">*</span>}
      </h3>
      <Input
        placeholder="Employee Id"
        value={EmployeeId}
        onChange={(e) => setEmployeeId(e.target.value)}
        disabled={isEditMode}
        className="EditInput"
      />
      {errors && EmployeeId === "" && !isEditMode && (
        <p style={{ color: "red", marginTop: -10, marginBottom: 0 }}>
          Employee Id is required
        </p>
      )}

      <h3 className="Title">
        User Name {!isEditMode && <span className="requiredStar">*</span>}
      </h3>
      <Input
        placeholder="User Name"
        value={UserName}
        onChange={(e) => setUserName(e.target.value)}
        disabled={isEditMode}
        className="EditInput"
      />
      {errors && UserName === "" && !isEditMode && (
        <p style={{ color: "red", marginTop: -10, marginBottom: 0 }}>
          User name is required
        </p>
      )}

      <h3 className="Title">
        Email ID {!isEditMode && <span className="requiredStar">*</span>}
      </h3>
      <Input
        placeholder="Email"
        value={Email}
        onChange={handleEmail}
        disabled={isEditMode}
        className="EditInput"
      />
      {errors && Email === "" && !isEditMode && (
        <p style={{ color: "red", marginTop: -10, marginBottom: 0 }}>
          Email Id is required
        </p>
      )}
      {emailError && (
        <p style={{ color: "red", marginTop: -10, marginBottom: 0 }}>
          {emailError}
        </p>
      )}

      {!isEditMode && (
        <>
          <h3 className="Title">
            Company <span className="requiredStar">*</span>
          </h3>
          <Select
            value={Status}
            placeholder="Select Company Name"
            className="EditInput"
            onChange={handleChange}
            options={CompanyOptions}
          />
          {errors && Status === null && (
            <p style={{ color: "red", marginTop: -10, marginBottom: 0 }}>
              Company is required
            </p>
          )}

          <h3 className="Title">
            Role <span className="requiredStar">*</span>
          </h3>
          <Select
            value={Role}
            placeholder="Select Role"
            className="EditInput"
            onChange={handleChangeRole}
            options={[
              { value: "user", label: "User" },
              { value: "manager", label: "Manager" },
            ]}
          />
          {errors && Role === null && (
            <p style={{ color: "red", marginTop: -10, marginBottom: 0 }}>
              Role is required
            </p>
          )}
        </>
      )}

      {isEditMode && (
        <p className="Title">Team</p>
      )}
      {!isEditMode && (
        <h3 className="Title">
          Teams <span className="requiredStar">*</span>
        </h3>
      )}
      <Select
        value={isEditMode ? undefined : teamId}
        defaultValue={isEditMode ? TeamNameDefault : undefined}
        placeholder="Select Team Name"
        className="EditInput"
        onChange={isEditMode ? handlechangeTeam : handleChangeTeam}
        options={TeamOptions}
      />
      {errors && teamId === null && !isEditMode && (
        <p style={{ color: "red", marginTop: -10, marginBottom: 0 }}>
          Team name is required
        </p>
      )}

      <h3 className="Title">
        Level {!isEditMode && <span className="requiredStar">*</span>}
      </h3>
      <Select
        value={level}
        placeholder="Select Level"
        className="EditInput"
        onChange={handleChangeLevel}
        dropdownRender={(menu) => (
          <>
            {menu}
            <Divider style={{ margin: "8px 0" }} />
            <Space direction="vertical" style={{ padding: "0 8px 4px" }}>
              <Input
                placeholder="Enter new level"
                value={newLevel}
                onChange={(e) => setNewLevel(e.target.value)}
                onPressEnter={handleLevelAdd}
              />
              <Space>
                <Button type="primary" onClick={handleLevelAdd}>
                  Add
                </Button>
                <Button danger onClick={handleLevelDelete} disabled={!level}>
                  Delete
                </Button>
              </Space>
            </Space>
          </>
        )}
      >
        {levels.map((lvl) => (
          <Option key={lvl} value={lvl}>
            {lvl}
          </Option>
        ))}
      </Select>
      {errors && !level && (
        <p style={{ color: "red", marginTop: -10, marginBottom: 0 }}>
          Level is required
        </p>
      )}

      <h3 className="Title">Manager</h3>
      <Select
        value={managerId}
        placeholder="Select Manager"
        className="EditInput"
        onChange={handleChangeManager}
        options={managerOptions}
      />

      <h3 className="Title">
        Domain {!isEditMode && <span className="requiredStar">*</span>}
      </h3>
      <Select
        value={domain}
        placeholder="Select Domain"
        className="EditInput"
        onChange={handleChangeDomain}
        dropdownRender={(menu) => (
          <>
            {menu}
            <Divider style={{ margin: "8px 0" }} />
            <Space direction="vertical" style={{ padding: "0 8px 4px" }}>
              <Input
                placeholder="Enter new domain"
                value={NewDomain}
                onChange={(e) => setNewDomain(e.target.value)}
                onPressEnter={handleDomainAdd}
              />
              <Space>
                <Button type="primary" onClick={handleDomainAdd}>
                  Add
                </Button>
                <Button danger onClick={handleDomainDelete} disabled={!domain}>
                  Delete
                </Button>
              </Space>
            </Space>
          </>
        )}
      >
        {domains.map((dom) => (
          <Option key={dom} value={dom}>
            {dom}
          </Option>
        ))}
      </Select>
      {errors && !domain && (
        <p style={{ color: "red", marginTop: -10, marginBottom: 0 }}>
          Domain is required
        </p>
      )}

      <h3 className="Title">
        Department {!isEditMode && <span className="requiredStar">*</span>}
      </h3>
      <Select
        value={department}
        placeholder="Select Department"
        className="EditInput"
        onChange={handleChangeDepartment}
        dropdownRender={(menu) => (
          <>
            {menu}
            <Divider style={{ margin: "8px 0" }} />
            <Space direction="vertical" style={{ padding: "0 8px 4px" }}>
              <Input
                placeholder="Enter new Department"
                value={NewDepartment}
                onChange={(e) => setNewDepartment(e.target.value)}
                onPressEnter={handleDepartmentAdd}
              />
              <Space>
                <Button type="primary" onClick={handleDepartmentAdd}>
                  Add
                </Button>
                <Button danger onClick={handleDepartmentDelete} disabled={!department}>
                  Delete
                </Button>
              </Space>
            </Space>
          </>
        )}
      >
        {departments.map((dept) => (
          <Option key={dept} value={dept}>
            {dept}
          </Option>
        ))}
      </Select>
      {errors && !department && (
        <p style={{ color: "red", marginTop: -10, marginBottom: 0 }}>
          Department is required
        </p>
      )}

      {isEditMode && (
        <>
          <p className="Title">Status</p>
          <Select
            value={Status}
            className="EditInput"
            onChange={handleChange}
            options={[
              { value: "true", label: "Active" },
              { value: "false", label: "Inactive" },
            ]}
          />
        </>
      )}

      <div style={{ marginTop: 16 }}>
        {isEditMode ? (
          <Checkbox
            checked={isNewBatch}
            onChange={(e) => setIsNewBatch(e.target.checked)}
          >
            New Batch User
          </Checkbox>
        ) : (
          <Tooltip title="This will add the user to a new batch so that multiple courses can be assigned at once.">
            <Checkbox
              checked={isNewBatch}
              onChange={(e) => setIsNewBatch(e.target.checked)}
            >
              New Batch
            </Checkbox>
          </Tooltip>
        )}
      </div>
    </Modal>
  );
};

export default AddEditUserModal;